import { useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";
import Modal from "../components/Modal";
import gallery from "../data/gallery";

const GALLERY_BASE = `${process.env.PUBLIC_URL}/gallery/`;

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <>
      <Nav />

      <div className="mx-auto max-w-content px-6 pb-14 pt-32 md:px-12 md:pb-20 md:pt-40">
        <p className="eyebrow">Culture &amp; Community</p>
        <h1 className="mt-3 font-serif text-4xl font-medium leading-tight text-teal-900 md:text-5xl">Gallery</h1>
        <p className="mt-5 max-w-[52ch] text-[0.95rem] leading-relaxed text-ink-soft">
          Moments from cultural programmes, festivals and milestones. Select any photo for a full-size view.
        </p>
      </div>

      <div className="mx-auto max-w-content px-6 pb-24 md:px-12">
        {gallery.length === 0 ? (
          <p className="border-t border-line pt-8 text-[0.9rem] text-ink-faint">Photos coming soon.</p>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {gallery.map((photo, i) => (
              <Reveal
                as="button"
                key={photo.file}
                delay={i * 60}
                onClick={() => setActive(photo)}
                className="group text-left"
              >
                <div className="aspect-[3/4] overflow-hidden bg-stone-50">
                  <img
                    src={GALLERY_BASE + photo.file}
                    alt={photo.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                </div>
                <p className="mt-3 font-serif text-base text-teal-900">{photo.title}</p>
                {photo.caption && <p className="mt-0.5 text-[0.78rem] text-ink-faint">{photo.caption}</p>}
              </Reveal>
            ))}
          </div>
        )}
      </div>

      <Modal open={!!active} onClose={() => setActive(null)} title={active?.title || ""}>
        {active && <img src={GALLERY_BASE + active.file} alt={active.title} className="max-h-[70vh] object-contain" />}
      </Modal>

      <Footer />
    </>
  );
}
